export default __webpack_public_path__ + "static/media/m_folder.dc3630d3.svg";